var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 2H12V6H16V18H2V2ZM0.9985 0C0.44749 0 0 0.44405 0 0.9918V19.0082C0 19.5447 0.44476 20 0.9934 20H17.0066C17.5551 20 18 19.5489 18 18.9925L17.9997 5L13 0H0.9985ZM7.4999 5.5C7.4999 7.07749 7.0442 8.9373 6.27493 10.6534C5.50287 12.3757 4.46143 13.8502 3.37524 14.7191L4.55464 16.3321C7.4821 14.3804 10.7233 13.0421 13.8585 13.49L14.3162 11.5513C11.6435 10.6604 9.4999 7.98994 9.4999 5.5H7.4999ZM8.0999 11.4716C8.3673 10.8752 8.6042 10.2563 8.8037 9.6285C9.2753 10.3531 9.8553 11.0182 10.5101 11.5953C9.5283 11.7711 8.5665 12.0596 7.6352 12.4276C7.7999 12.1143 7.9551 11.7948 8.0999 11.4716Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/PDF.55a4d685f6fa9675a34598a7375fcb38.svg";
export { ForwardRef as ReactComponent };